var EHDI = EHDI || Object.create(null);

EHDI.scene = EHDI.scene || Object.create(null);

EHDI.scene.PostGameScene = function() {
    EHDI.aka.Container.call(this);
    
    var _this = this;
    
    var _radial, _radialTween;
    var _endCurtainArma, _endCurtainSpr;
    var _endMessage;
    
    var _fishGroup = [];
    var _fishIndex = 0;
    var _fishTimer = 0;
    var _fallThresh = EHDI.NumberUtil.randomRange( 0.2, 0.6 );
    
    var _continueBtn, _titleBtn;
    
    this.screenWillAppear = function() {
        var bg = new EHDI.aka.Sprite(EHDI.Assets.images["end_bg"]);
        bg.anchor.set(0.5, 0.5);
        
        _this.addChild(bg);
    }
    
    this.screenDidAppear = function() {
        _radial = new EHDI.aka.Sprite( EHDI.Assets.images["end_radial"] );
        _radial.anchor.set( 0.5, 0.5 );
        _radial.alpha = 0;
        _this.addChild( _radial );
        
        _endCurtainArma = EHDI.GAME.dbFactory.buildArmature("bugs_end");
        _endCurtainSpr = _endCurtainArma.getDisplay();
        _endCurtainSpr.position.y = EHDI.screen.viewHeight * 0.5;
        _this.addChild( _endCurtainSpr );
        
        _fishLayer = new EHDI.aka.Container();
        _fishLayer.position.set( EHDI.screen.viewWidth * -0.5, EHDI.screen.viewHeight * -0.5 );
        _this.addChild( _fishLayer );
        createFish();
        
        _endMessage = new EHDI.aka.Sprite( EHDI.Assets.images["WB_congrats_word"] );
        _endMessage.anchor.set( 0.5, 0.5 );
        _endMessage.position.y = EHDI.screen.viewHeight * -0.65;
        _this.addChild( _endMessage );
        
        _continueBtn = new EHDI.displays.Button(EHDI.Assets.images["btn_continue"], null, null, null, 0.8);
        _continueBtn.setOnClickFunction( onContinuePressed );
        _continueBtn.position.set( EHDI.screen.viewWidth * -0.05, EHDI.screen.viewHeight * 0.65 );
        _this.addChild( _continueBtn );
        _continueBtn.disable( true );
        
        _titleBtn = new EHDI.displays.Button(EHDI.Assets.images["btn_home"], null, null, null, 0.8);
        _titleBtn.setOnClickFunction( onTitlePressed );
        _titleBtn.position.set( EHDI.screen.viewWidth * 0.05, EHDI.screen.viewHeight * 0.65 );
        _this.addChild( _titleBtn );
        _titleBtn.disable( true );
        
        EHDI.GAME.updateManager.addFrameListener(updateDBWorldClock);
        
        dragonBones.WorldClock.clock.add( _endCurtainArma );
        _endCurtainArma.animation.gotoAndPlay( "entrance", -1, -1, 1 );
        
        _endCurtainArma.addEventListener(dragonBones.FrameEvent.ANIMATION_FRAME_EVENT, curtainEventHandler);
    }
    
    var createFish = function(){
        var commonData = EHDI.Assets.fetch( "rarity_0" );
        var uncommonData = EHDI.Assets.fetch( "rarity_1" );
        var rareData = EHDI.Assets.fetch( "rarity_2" );
        var fishList = [];
        
        for( var i = 0; i < commonData.fish.length; i++ ){ fishList.push( commonData.fish[ i ] ); }
        for( var i = 0; i < uncommonData.fish.length; i++ ){ fishList.push( uncommonData.fish[ i ] ); }
        for( var i = 0; i < rareData.fish.length; i++ ){ fishList.push( rareData.fish[ i ] ); }
        
        for( var i = 0; i < fishList.length; i++ ){
            var curFishData = fishList[ i ];
            
            var fishData = { spr: null, xSpeed: 0, ySpeed: 0 };
            fishData.spr = new EHDI.aka.Sprite( EHDI.Assets.images[ curFishData.asset ] );
            fishData.spr.scale.set( 0.5, -0.5 );
            fishData.spr.anchor.set( 0.5, 0.5 );
            fishData.spr.position.y = EHDI.screen.viewHeight * -0.2;
            fishData.spr.visible = false;
            _fishLayer.addChild( fishData.spr );
            _fishGroup.push( fishData );
        }
    }
    
    var updateDBWorldClock = function( dt ){
        dragonBones.WorldClock.clock.advanceTime(dt * 0.001);
    }
    
    var updatePost = function( dt ){
        dt = dt / 1000;
        _fishTimer += dt;
        
        if( _fishTimer > _fallThresh ){
            _fishTimer = 0;
            _fallThresh = EHDI.NumberUtil.randomRange( 0.2, 0.6 );
            
            var curFish = _fishGroup[ _fishIndex ];
            curFish.spr.position.x = EHDI.screen.viewWidth * EHDI.NumberUtil.randomRange( 0.1, 0.9 );
            curFish.spr.position.y = EHDI.screen.viewHeight * -0.2;
            curFish.spr.visible = true;
            curFish.ySpeed = EHDI.NumberUtil.randomRange( 250, 500 );
            curFish.xSpeed = EHDI.NumberUtil.randomRange( 0, 200 );
            if( Math.random() < 0.5 ) curFish.xSpeed *= -1;
            
            _fishIndex++;
            if( _fishIndex >= _fishGroup.length ) _fishIndex = 0;
        }
        
        for( var i = 0; i < _fishGroup.length; i++ ){
            var curFish = _fishGroup[ i ];
            curFish.spr.position.x = curFish.spr.position.x + ( curFish.xSpeed * dt );
            curFish.spr.position.y = curFish.spr.position.y + ( curFish.ySpeed * dt );
            
            if( curFish.xSpeed < -25 ){
                curFish.spr.rotation = curFish.spr.rotation + ( (curFish.xSpeed * 0.02) * dt );
            }
            else if( curFish.xSpeed > 25 ){
                curFish.spr.rotation = curFish.spr.rotation + ( (curFish.xSpeed * 0.02) * dt );
            }
            
            if( ( curFish.spr.position.x < EHDI.screen.viewWidth * -0.15 ||
                curFish.spr.position.x > EHDI.screen.viewWidth * 1.15 ||
                curFish.spr.position.y > EHDI.screen.viewHeight * 1.2 ) &&
                curFish.xSpeed !== 0
              ){
                curFish.xSpeed = 0;
                curFish.ySpeed = 0;
                curFish.spr.visible = false;
            }
        }
    }
    
    var introFinished = function(){
        EHDI.GAME.updateManager.addFrameListener(updatePost);
        _continueBtn.disable( false );
        _titleBtn.disable( false );
    }
    
    var onContinuePressed = function(){
        EHDI.GAME.soundManager.playSFX("button_01");
        EHDI.GAME.sceneManager.changeScene( new EHDI.scene.GameScene() );
    }
    
    var onTitlePressed = function(){
        EHDI.GAME.soundManager.playSFX("button_01");
        EHDI.GAME.sceneManager.changeScene( new EHDI.scene.TitleScene() );
    }
    
    var curtainEventHandler = function( event ){
        if( event.frameLabel === "bugs_entered" ){
            TweenMax.to( _endMessage, 0.75, { y: EHDI.screen.viewHeight * -0.36 } );
            TweenMax.to( _radial, 0.5, { alpha: 1.0 } );
            _radialTween = TweenMax.to( _radial, 8, { rotation: 2 * Math.PI, ease:Linear.easeNone, repeat: -1 } );
            TweenMax.to( _continueBtn, 0.5, { y: EHDI.screen.viewHeight * 0.36 } );
            TweenMax.to( _titleBtn, 0.5, { 
                y: EHDI.screen.viewHeight * 0.36, 
                onComplete: introFinished
            } );
        }
    }
    
    this.onScreenResize = function() {
        _endCurtainSpr.position.y = EHDI.screen.viewHeight * 0.5;
        _fishLayer.position.set( EHDI.screen.viewWidth * -0.5, EHDI.screen.viewHeight * -0.5 );
        _endMessage.position.y = EHDI.screen.viewHeight * -0.65;
        _continueBtn.position.set( EHDI.screen.viewWidth * -0.05, EHDI.screen.viewHeight * 0.65 );
        _titleBtn.position.set( EHDI.screen.viewWidth * 0.05, EHDI.screen.viewHeight * 0.65 );
    }
    
    this.dispose = function() {
        _radialTween.kill();
        EHDI.GAME.updateManager.removeFrameListener(updateDBWorldClock);
        EHDI.GAME.updateManager.removeFrameListener(updatePost);
    }
}

EHDI.scene.PostGameScene.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.scene.PostGameScene.prototype.destroy = function() {
    this.dispose();
    EHDI.aka.Container.prototype.destroy.apply(this, arguments);
}

